<app-page-with-sections
    source="App.ScientificResearchPage"
    [linksMap]="linksMap">
</app-page-with-sections>
